import React from 'react'

const Map = () => {

    return (
        <>
            <div id='map-container'>
                <div id='map' style={{ width: '100%', height: '60vh' }}></div>
            </div>
        </>
    )
}

export default Map